import styled from 'styled-components';

import Markdown from '@glowforge/gf-styled/src/components/markdown';
import { Title } from '@glowforge/gf-styled/src/components/typography/Typography';
import GridContainer from '@glowforge/gf-styled/src/components/grid-container/grid-container';
import LinkBase from '@glowforge/gf-styled/src/components/link/link-base';

export const Wrapper = styled(GridContainer)`
  background-color: ${(props) => props.theme.colors.backgrounds.gray};
  padding-bottom: 64px;
`;

export const CountryLink = styled(LinkBase)`
  display: flex;
  margin: 24px 0;

  img {
    height: 20px;
    margin-right: 8px;
  }
`;

export const NavigationWrapper = styled('nav')`
  grid-column: main-start / main-end;
  margin: 0 auto;
  margin-top: 48px;

  @media ${(props) => props.theme.queries.desktopAndUp} {
    margin-top: 300px;
    grid-column: main-start / col-end 3;
  }
`;

export const ListWrapper = styled('ul')`
  list-style: none;
`;

export const ContentWrapper = styled('div')`
  grid-column: main-start / main-end;

  @media ${(props) => props.theme.queries.desktopAndUp} {
    grid-column: ${(props) =>
        props.hasCountryNav ? `col-start 4` : `main-start`} / main-end;
  }
`;

export const Heading = styled(Title)`
  padding: 32px 0 64px 0;
  text-align: center;
`;

export const LegalMarkdown = styled(Markdown)`
  h1 {
    font-size: 3rem;
  }
  ol,
  ul {
    // reduce from 40px, mobile nesting can get quite deep
    padding-left: 20px;
  }

  ol:first-of-type {
    counter-reset: item;
  }

  ol > li {
    display: block;

    p:first-child {
      // Pulls first paragraph in an LI up next to the number
      display: inline;
    }
  }

  ol > li::before {
    content: counters(item, '.') '. ';
    counter-increment: item;
  }

  ul > li {
    list-style: lower-alpha;
  }
`;
